export default "__VITE_ASSET__BrPm9XN7__"